import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */
import * as Actions from '../../redux/actions';
import {addPopup} from "../../redux/actions";
import * as popups from "../../constants/popup-types";


class VerifyCartRequest extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'VerifyCartRequest';
        this.Config   = new AppConfig();
        this.payload  = null;
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;

        this.dispatch(Actions.setVerificationStatus(false));

        //save payload for doPayment in case of success
        this.payload = payload;

        this.call(this.Config.api.requests.verifyCart);
    }

    //Parse successful response
    onSuccess() {
        let data = this.response.data;
        this.updateState(data);
    }

    //Dispatch actions to update redux state
    updateState() {
        this.dispatch(Actions.setVerificationStatus(true));
    }

    onFailure(response){
        // let err_msg = 'תקלת שרת, אנא נסה שנית מאוחר יותר';
        // if(response.data) {
        //     err_msg = response.data.content;
        // }
        // this.dispatch(addPopup({
        //     type:popups.GENERAL_MESSAGE,
        //     text: err_msg,
        //     popup_id: Math.round(Math.random() * 1000000)
        // }));
        //
        this.dispatch(Actions.setOrderDone({err: response.data.content}));
    }
}


export default VerifyCartRequest;